/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, every occurrence is replaced. 'Whole word only' (literal mode) prevents matching inside longer words, e.g. 'cat' won't match 'category'.`)
};

const es_fr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí, cada ocurrencia se reemplaza. 'Solo palabras completas' (modo literal) evita coincidir dentro de palabras más largas, p. ej. cat no coincidirá con category.`)
};

const de_fr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, jedes Vorkommen wird ersetzt. „Nur ganze Wörter” (wörtlicher Modus) verhindert Übereinstimmungen innerhalb längerer Wörter, z. B. trifft cat nicht auf category.`)
};

const nl_fr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, elk voorkomen wordt vervangen. 'Alleen hele woorden' (letterlijke modus) voorkomt bijpassingen binnen langere woorden, bijv. 'cat' zal niet 'category' matchen.`)
};

const fr_fr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui, chaque occurrence est remplacée. « Mot entier uniquement » (mode littéral) empêche la correspondance à l'intérieur de mots plus longs, par exemple « cat » ne correspondra pas à « category ».`)
};

const it_fr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì, ogni occorrenza viene sostituita. 'Solo parola intera' (modalità letterale) impedisce la corrispondenza all'interno di parole più lunghe, ad es. 'cat' non corrisponderà a 'category'.`)
};

const pt_br2_fr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, todas as ocorrências são substituídas. 'Apenas palavra completa' (modo literal) evita correspondência dentro de palavras mais longas, por exemplo cat não corresponderá a category.`)
};

const pt_fr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, toda ocorrência é substituída. 'Apenas palavras inteiras' (modo literal) evita correspondência dentro de palavras mais longas, por exemplo, 'cat' não corresponderá a 'category'.`)
};

const ja_fr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい、すべての出現が置換されます。「単語全体のみ」（リテラルモード）は長い単語内でのマッチを防ぎます。例えば、「cat」は「category」とマッチしません。`)
};

const zh_fr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的，每一处匹配都会被替换。“仅匹配整个单词”（字面模式）可防止匹配出现在更长单词内部，例如“cat”不会匹配“category”。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_faq2_a", locale)
	if (locale === "en") return en_fr_faq2_a(inputs)
	if (locale === "es") return es_fr_faq2_a(inputs)
	if (locale === "de") return de_fr_faq2_a(inputs)
	if (locale === "nl") return nl_fr_faq2_a(inputs)
	if (locale === "fr") return fr_fr_faq2_a(inputs)
	if (locale === "it") return it_fr_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_fr_faq2_a(inputs)
	if (locale === "pt") return pt_fr_faq2_a(inputs)
	if (locale === "ja") return ja_fr_faq2_a(inputs)
	return zh_fr_faq2_a(inputs)
};